import React from "react";

const TreasureBoxSettings = React.lazy(() => import('src/pages/treasure_box_settings/TreasureBoxSettings'));

const routes = [
    { path: '/dashboard/treasure-box-settings', name: 'Treasure Box Settings', element: TreasureBoxSettings },
];

export default routes;
